import { render } from "./TerminationForm.vue?vue&type=template&id=68b0bfda"
import script from "./TerminationForm.vue?vue&type=script&lang=js"
export * from "./TerminationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__